module.exports = __webpack_public_path__ + "media/images/stock_groups/e53a-c0ac6fe0191647b194caf759440e50d4.svg";